import { requestApi } from '../util/network'

// 卖家退出登录
export const vactInfo =
    (id,token) =>
      requestApi(
        '/Activity/vact_info',
        'POST',
        {
          activity_id: id,
          key:token
        }
      )
export const vact_fdetail =
    (params) =>
      requestApi(
        '/Activity/vact_fdetail',
        'POST',
        {
           ...params
        }
      )
export const vact_receive =
(params) =>
  requestApi(
    '/Activity/vact_receive',
    'POST',
    {
        ...params
    },
    'member'
  )
      